export default __webpack_public_path__ + "static/media/still-life1.e17eb135.png";